import React from "react";

const MailIcon = () => (
  <svg
    width="84"
    height="91"
    viewBox="0 0 84 91"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M40.041 0.748024L2.55471 34.2699C-2.31639 38.638 0.757834 46.729 7.30999 46.729H76.6901C83.2422 46.729 86.333 38.638 81.4453 34.2699L43.9458 0.748024C43.4095 0.26641 42.7142 0 41.9934 0C41.2726 0 40.5773 0.26641 40.041 0.748024Z"
      fill="#386CAB"
    />
    <path
      d="M84 40.018V84.1789C84 85.8929 83.3191 87.5368 82.1071 88.7488C80.8951 89.9608 79.2512 90.6417 77.5372 90.6417H6.46281C4.74877 90.6417 3.10493 89.9608 1.89291 88.7488C0.680902 87.5368 8.48148e-07 85.8929 8.48148e-07 84.1789V40.018C-0.000434115 39.1692 0.166435 38.3286 0.491067 37.5443C0.8157 36.76 1.29173 36.0473 1.89194 35.4471C2.49216 34.8469 3.20479 34.3709 3.98909 34.0462C4.77339 33.7216 5.61398 33.5547 6.46281 33.5552H77.5372C78.3863 33.5539 79.2272 33.7202 80.0119 34.0445C80.7966 34.3688 81.5096 34.8448 82.11 35.4452C82.7104 36.0456 83.1864 36.7585 83.5107 37.5432C83.835 38.3279 84.0013 39.1689 84 40.018Z"
      fill="#3D77BC"
    />
    <path
      d="M42 62.0968L6.46281 90.6384C4.88023 90.6389 3.35248 90.0586 2.16921 89.0077C0.985936 87.9568 0.229396 86.5082 0.0430192 84.9367C0.0153056 84.685 0.000945741 84.4321 0 84.1789L0 40.018C0.00096314 39.5428 0.0531075 39.069 0.155531 38.605L42 62.0968Z"
      fill="#CDD8E5"
    />
    <path
      d="M83.9999 40.018V84.1789C83.9999 85.8929 83.319 87.5367 82.107 88.7488C80.895 89.9608 79.2512 90.6417 77.5371 90.6417H6.46276C4.87988 90.6413 3.3521 90.0604 2.1689 89.0089C0.985704 87.9575 0.229286 86.5085 0.0429688 84.9367L41.9999 62.1034L83.861 38.7009C83.9314 39.1371 83.9778 39.5767 83.9999 40.018Z"
      fill="#D8E4F2"
    />
    <path
      d="M39.4461 50.4087C38.9097 50.4091 38.3785 50.3038 37.8828 50.0988C37.3871 49.8938 36.9367 49.5932 36.5572 49.2141L21.57 34.2236C20.8804 33.4442 20.5145 32.4309 20.5469 31.3908C20.5793 30.3506 21.0076 29.3621 21.7443 28.6271C22.481 27.8921 23.4705 27.4661 24.5107 27.4361C25.5509 27.4061 26.5633 27.7743 27.3411 28.4656L39.4461 40.5673L66.3 13.7133C67.0768 13.0156 68.0914 12.6419 69.1352 12.6691C70.179 12.6963 71.1727 13.1223 71.9121 13.8596C72.6515 14.5969 73.0804 15.5894 73.1106 16.6331C73.1408 17.6769 72.77 18.6925 72.0745 19.4713L42.3317 49.2141C41.5661 49.9789 40.5282 50.4086 39.4461 50.4087Z"
      fill="white"
    />
  </svg>
);

export default MailIcon;
